/**
 * @generated SignedSource<<e327f17187d3deb227c8ac3dd8616d14>>
 * @relayHash 82b2265735f350b04303aa356c63fa98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c8bcc1494388137507cfc8874c8299406aa298c24af339e264e7dc02dc5cbbd

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PageTreeQueryWithSpaceKeyQuery$variables = {
  isSuperAdmin: boolean;
  paginationLimit?: number | null | undefined;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null | undefined> | null | undefined;
  spaceKey: string;
};
export type PageTreeQueryWithSpaceKeyQuery$data = {
  readonly ptpage: {
    readonly blank: boolean | null | undefined;
    readonly createdDate: {
      readonly value: string;
    } | null | undefined;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null | undefined;
        readonly createdDate: {
          readonly value: string;
        } | null | undefined;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null | undefined;
    } | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
        readonly version: {
          readonly number: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly status: PTGraphQLPageStatus | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly homepageId: string | null | undefined;
    readonly id: string | null | undefined;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
      readonly targetType: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageTree: {
      readonly blank: boolean | null | undefined;
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null | undefined;
          readonly createdDate: {
            readonly value: string;
          } | null | undefined;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null | undefined;
          } | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null | undefined;
              readonly key: string | null | undefined;
              readonly value: string | null | undefined;
              readonly version: {
                readonly number: number | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status: PTGraphQLPageStatus | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null | undefined;
      } | null | undefined;
      readonly createdDate: {
        readonly value: string;
      } | null | undefined;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null | undefined;
          readonly createdDate: {
            readonly value: string;
          } | null | undefined;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null | undefined;
          } | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null | undefined;
              readonly key: string | null | undefined;
              readonly value: string | null | undefined;
              readonly version: {
                readonly number: number | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status: PTGraphQLPageStatus | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null | undefined;
      } | null | undefined;
      readonly hasChildren: boolean;
      readonly hasInheritedRestrictions?: boolean;
      readonly hasRestrictions?: boolean;
      readonly id: string;
      readonly links: {
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null | undefined;
          readonly createdDate: {
            readonly value: string;
          } | null | undefined;
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly blank: boolean | null | undefined;
              readonly createdDate: {
                readonly value: string;
              } | null | undefined;
              readonly hasChildren: boolean;
              readonly hasInheritedRestrictions?: boolean;
              readonly hasRestrictions?: boolean;
              readonly id: string;
              readonly links: {
                readonly webui: string | null | undefined;
              } | null | undefined;
              readonly properties: {
                readonly nodes: ReadonlyArray<{
                  readonly id: string | null | undefined;
                  readonly key: string | null | undefined;
                  readonly value: string | null | undefined;
                  readonly version: {
                    readonly number: number | null | undefined;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly status: PTGraphQLPageStatus | null | undefined;
              readonly subType: string | null | undefined;
              readonly title: string | null | undefined;
              readonly type: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null | undefined;
          } | null | undefined;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null | undefined;
          } | null | undefined;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly blank: boolean | null | undefined;
              readonly createdDate: {
                readonly value: string;
              } | null | undefined;
              readonly hasChildren: boolean;
              readonly hasInheritedRestrictions?: boolean;
              readonly hasRestrictions?: boolean;
              readonly id: string;
              readonly links: {
                readonly webui: string | null | undefined;
              } | null | undefined;
              readonly properties: {
                readonly nodes: ReadonlyArray<{
                  readonly id: string | null | undefined;
                  readonly key: string | null | undefined;
                  readonly value: string | null | undefined;
                  readonly version: {
                    readonly number: number | null | undefined;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly status: PTGraphQLPageStatus | null | undefined;
              readonly subType: string | null | undefined;
              readonly title: string | null | undefined;
              readonly type: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null | undefined;
          } | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null | undefined;
              readonly key: string | null | undefined;
              readonly value: string | null | undefined;
              readonly version: {
                readonly number: number | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status: PTGraphQLPageStatus | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        } | null | undefined;
      } | null | undefined;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null | undefined;
          readonly createdDate: {
            readonly value: string;
          } | null | undefined;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null | undefined;
          } | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null | undefined;
              readonly key: string | null | undefined;
              readonly value: string | null | undefined;
              readonly version: {
                readonly number: number | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status: PTGraphQLPageStatus | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null | undefined;
      } | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly status: PTGraphQLPageStatus | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PageTreeQueryWithSpaceKeyQuery = {
  response: PageTreeQueryWithSpaceKeyQuery$data;
  variables: PageTreeQueryWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "kind": "ScalarField",
  "name": "status"
},
v8 = {
  "kind": "ScalarField",
  "name": "value"
},
v9 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v10 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v11 = {
  "kind": "ScalarField",
  "name": "blank"
},
v12 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "type"
},
v14 = {
  "kind": "ScalarField",
  "name": "subType"
},
v15 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v16 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v8/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v17 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v18 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ]
  },
  {
    "concreteType": "PTPageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v17/*: any*/)
    ]
  }
],
v19 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v18/*: any*/)
},
v20 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v18/*: any*/)
},
v21 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "ScalarField",
        "name": "homepageId"
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "enablePaging",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "pageTree",
            "variableName": "paginationLimit"
          },
          (v5/*: any*/)
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "pageTree",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
              {
                "concreteType": "PTPageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              },
              {
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ]
              }
            ]
          },
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": (v18/*: any*/)
          }
        ]
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      (v5/*: any*/)
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v20/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreeQueryWithSpaceKeyQuery",
    "selections": (v21/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreeQueryWithSpaceKeyQuery",
    "selections": (v21/*: any*/)
  },
  "params": {
    "cacheID": "82b2265735f350b04303aa356c63fa98",
    "id": "4c8bcc1494388137507cfc8874c8299406aa298c24af339e264e7dc02dc5cbbd",
    "metadata": {},
    "name": "PageTreeQueryWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query PageTreeQueryWithSpaceKeyQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean!){space(key:$spaceKey){id,homepageId,pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},operations{operation,targetType}},ptpage(spaceKey:$spaceKey,status:$ptStatuses){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
  }
};
})();

(node as any).hash = "137002c22c870934b43526f73e5db7fe";

export default node;
